import React, { forwardRef, useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { Typography } from '../typography';
import styles from './styles.module.css';
import { useRadioGroup } from '../radio-group';
/**
 * `<Radio>` - единичная Радио-Кнопка.
 * @example ```tsx
 <Radio label="Yes" value="Yes" onChange={handleChange} />
 * ```
 */
export const Radio = /*#__PURE__*/forwardRef(function Radio({
  label,
  className,
  onChange: onChangeProp,
  name: nameProp,
  checked: checkedProp,
  radioSize = 'm',
  alert,
  ...rest
}, ref) {
  const [variant, size] = labelVariantsBySize[radioSize];
  const radioGroupContext = useRadioGroup();
  const onChange = useCallback(e => {
    onChangeProp == null ? void 0 : onChangeProp(e);
    radioGroupContext == null ? void 0 : radioGroupContext.onChange(e);
  }, [onChangeProp, radioGroupContext]);
  let checked = checkedProp;
  let name = nameProp;
  if (radioGroupContext) {
    if (typeof checkedProp === 'undefined') {
      checked = radioGroupContext.value === rest.value;
    }
    if (typeof name === 'undefined') {
      name = radioGroupContext.name;
    }
  }
  const outerClassName = useMemo(() => clsx(styles.radio, className, {
    [styles.block]: /*#__PURE__*/React.isValidElement(label),
    [styles.disabled]: rest.disabled
  }), [className, label, rest.disabled]);
  const radioIconClassName = useMemo(() => clsx(styles.radioIcon, styles[radioSize], {
    [styles.alert]: alert
  }), [radioSize, alert]);
  const labelClassName = useMemo(() => clsx(styles.labelText, styles[radioSize]), [radioSize]);
  return /*#__PURE__*/React.createElement("label", {
    ref: ref,
    className: outerClassName,
    "data-testid": "radio-button"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.inputContainer
  }, /*#__PURE__*/React.createElement("input", {
    ...rest,
    className: styles.inputInner,
    onChange: onChange,
    name: name,
    checked: checked,
    type: "radio",
    "data-testid": "radio-input"
  }), /*#__PURE__*/React.createElement("div", {
    className: radioIconClassName
  })), label && (/*#__PURE__*/React.createElement(Typography, {
    as: "span",
    className: labelClassName,
    variant: variant,
    size: size,
    "data-testid": "radio-label"
  }, label)));
});
const labelVariantsBySize = {
  l: ['m', 'body_short'],
  m: ['s', 'body_short']
};